import React from "react";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import First from "./Extra/First_section/First";
import Second from "./Extra/Second_section/Second";
import Last from "./Extra/Last_section/Last";
import Third from "./Extra/Third_section/Third";

const Indus = () => {
  return (
    <>
      <Header />
      <First />
      <Second />
      <Third />
      <Last />
      <Footer />
    </>
  );
};

export default Indus;
